module.exports = __webpack_public_path__ + "img/banana.36fd31ea.svg";